import { INavigationService } from '../../services/navigationService';
import { IRoutesService } from '../../services/RoutesService';
import { ITenantHandlerService } from '../../services/tenantHandler';
import { Refreshable } from '../../utils/refreshable/IRefreshable';
import { internalLogger } from '../../interface/v1/clientOsLogger';

export type RenewTenantHandlerKeyType = {
  routesService: IRoutesService;
  navigationService: INavigationService;
  tenantHandlerService: ITenantHandlerService;
};

export default class RenewTenantHandlerKey extends Refreshable {
  private _tenantHandlerService: ITenantHandlerService;
  private _routesService: IRoutesService;
  private _navigationService: INavigationService;
  constructor({
    routesService,
    navigationService,
    tenantHandlerService
  }: RenewTenantHandlerKeyType) {
    super();
    this._tenantHandlerService = tenantHandlerService;
    this._routesService = routesService;
    this._navigationService = navigationService;

    this.setRefreshMethods({
      init: this.init.bind(this),
      refresh: this.init.bind(this)
    });
  }

  public async init(): Promise<void> {
    return this._renewTenantHandlerKey();
  }

  private _renewTenantHandlerKey = async () => {
    /* istanbul ignore next */
    internalLogger?.debug?.('Renewing tenant handler key...');
    const tenantHandlerOverride = await this._getTenantHandlerOverride();
    await this._tenantHandlerService?.setTenantHandlerKey(
      tenantHandlerOverride,
      true
    );
  };

  private _getTenantHandlerOverride = async () => {
    const currentPath = this._navigationService.location.pathname;
    const { tenantHandlerOverride } =
      (await this._routesService?.findRouteWithPriority?.(
        currentPath,
        false
      )) || {};
    return tenantHandlerOverride;
  };
}
